import Vue from 'vue';
import Vuex from 'vuex';

import entry from './modules/entry';

Vue.use( Vuex );
require( 'es6-promise' ).polyfill();

export default new Vuex.Store({
    strict: true,

    modules: {
        entry
    },

    state: {
        index: 0,
        liveDatum: new Date( 2021, 6, 1, 8, 30, 0 )
    },

    getters: {
        index: ({ index }) => index,
        route: ({ route }) => route,
        liveDatum: state => state.liveDatum
    },

    mutations: {
        index: ( state, payload ) =>
        {
            state.index = payload;
        },
        liveDatum: ( state, payload ) =>
        {
            state.liveDatum = payload;
        }
    },

    actions: {
        index: ( context, payload ) =>
        {
            context.commit( 'index', payload );
        },
        liveDatum: ( context, payload ) =>
        {
            context.commit( 'liveDatum', payload );
        }
    }
});
